import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import countries from 'assets/json/countries.json';
import { ToastService } from 'app/components/toasts/toasts.service';
import { CoreConfigService } from '@core/services/config.service';
import { DataService } from 'app/services/data.service';
import { AuthenticationService } from 'app/auth/service/authentication.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProfileComponent implements OnInit {

  public coreConfig: any;
  public loading: boolean = false;
  private phone_regex = /^(1-)?\d{3}-\d{3}-\d{4}$/;

  public oldPassword: boolean;
  public newPassword: boolean;
  public confirmPassword: boolean;
  public error: string = null;
  public message: string = null;

  public countries = null;
  public minCountForSearch = 5;
  public overlay = false;
  public avatarImage: string = 'assets/images/portrait/small/unisexprofile.jpg';
  private profilePicture: File = null;
  public user_form: FormGroup = new FormGroup({
    fullName: new FormControl(null, Validators.required),
    email: new FormControl(null, [Validators.required, Validators.email]),
    hearAboutUs: new FormControl(null, Validators.required),
    defaultProduct: new FormControl(null, Validators.required),
    isNewsletter: new FormControl(null, Validators.required),
    walletAddress: new FormControl(null)
  });

  public user_info: any;

  public change_password: FormGroup = new FormGroup({
    oldPassword: new FormControl(null, Validators.required),
    newPassword: new FormControl(null, Validators.required),
    confirmPassword: new FormControl(null, Validators.required)
  }, {
    validators: this.password.bind(this)
  })

  constructor(
    public toastService: ToastService,
    private _coreConfigService: CoreConfigService,
    private dataService: DataService,
    private authService: AuthenticationService) {
    this._coreConfigService.config = {
      layout: {
        menu: {
          hidden: true,
          collapsed: false
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {

    this.user_info = this.authService.currentUserValue;
    countries.forEach(element => {
      element['value'] = element['label'];
    });
    this.countries = countries;
    this.user_form.get('email').setValue(this.user_info.user.email);
    this.user_form.get('fullName').setValue(this.user_info.user.fullName)
    this.user_form.get('hearAboutUs').setValue(this.user_info.user.hearAboutUs);
    this.user_form.get('defaultProduct').setValue(this.user_info.user.defaultProduct);
    this.user_form.get('isNewsletter').setValue(this.user_info.user.isNewsletter);
    this.user_form.get('walletAddress').setValue(this.user_info.user.walletAddress == 'null' ? '' : this.user_info.user.walletAddress);
    if(this.user_info.user.profilePhoto !== ''){
      this.avatarImage = this.user_info.user.profilePhoto;
    }
  }

  submit(){
    if(this.user_form.valid){
      this.loading = true;
      let formdata = this.user_form.value;
      let fd = new FormData();
      for (const key in formdata) {
        fd.append(key, formdata[key]);
      }
      if(this.profilePicture){
        fd.append('image', this.profilePicture);
      }
      this.dataService.updateUser(fd).subscribe((result)=>{
        if(result.code == 1001){
          this.user_info.user.firstname = this.user_form.value.firstname;
          this.user_info.user.lastname = this.user_form.value.lastname;
          this.user_info.user.country = this.user_form.value.country;
          this.user_info.user.phoneNumber = this.user_form.value.phoneNumber;
          if(result.data.profilePhoto){
            this.user_info.user.profilePhoto = result.data.profilePhoto;
          }
          this.dataService.refreshUserToken().toPromise().then((result:any) =>{
            this.authService.setUser(result.data);
          });
          this.toastService.show('Profile Updated', {
            delay: 2000,
            classname: 'bg-success text-light',
            autohide: true
          });
          this.loading = false;
        } else {
          this.toastService.show(`${result.message}`, {
            delay: 2000,
            classname: 'bg-danger text-light',
            autohide: true
          });
        }
      });
    } else {
      this.user_form.markAllAsTouched();
    }
  }

  changePassword(){
    this.error = null;
    this.message = null;
    if (this.change_password.valid) {
      let data = this.change_password.value;
      data['email'] = this.user_info.user.email;
      this.dataService.changeUserPassword(data).toPromise().then((result)=>{
        if(result.code == 1001){
          this.toastService.show('Password changed', {
            delay: 2000,
            classname: 'bg-success text-light',
            autohide: true
          });
        }
      }).catch((err) =>{
        this.error = err;
      });
    } else {
      if(this.change_password.errors.passwordNotMatch){
        this.error = 'Password not match';
      }
      this.change_password.markAllAsTouched();
    }
  }

  changePasswordToText(prop){
    switch (prop) {
      case 'oldPassword':
        this.oldPassword = this.oldPassword ? false : true;
        break;
      case 'newPassword':
        this.newPassword = this.newPassword ? false : true;
        break;
      case 'confirmPassword':
        this.confirmPassword = this.confirmPassword ? false : true;
        break;
    }
  }

  password(formGroup: FormGroup) {
    const { value: password } = formGroup.get('newPassword');
    const { value: confirmPassword } = formGroup.get('confirmPassword');
    return password === confirmPassword ? null : { passwordNotMatch: true };
  }


  uploadImage(event: any) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();

      reader.onload = (event: any) => {
        this.avatarImage = event.target.result;
      };

      reader.readAsDataURL(event.target.files[0]);
      this.profilePicture = event.target.files[0];
    }
  }

}
